<template>
  <div>
    <div :style="{height:topHeight}">
      <div class="top-box" :style="{'height':topHeight,'background-color':colorTopBg}"></div>
    </div>
    <van-nav-bar id="barTitle" style="height:54px" :class="bgType=='1'? 'dr-bar-title' : bgType=='3'?'dr-bar-title1':'dr-bav-bar'" fixed placeholder
      :title="barName" right-text="rightText" :left-arrow="false"
      @click-right="onClickRight" :border="false">
      <template #left>
        <van-icon v-if="leftArrow && !customBack" :name="bgType=='1' ? 'static/imgs/back.png':'static/imgs/back_black.png'" size="20" @click="onClickLeft" />
        <van-icon v-else-if="leftArrow && customBack" :name="bgType=='1' ? 'static/imgs/back.png':'static/imgs/back_black.png'" size="20" @click="onCustomBackClick" />
        <slot v-else></slot>
      </template>
      <template #right>
        <dr-row alignItems="center">
          <slot></slot>
        </dr-row>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  props: {
    bgType: {
      type: String,
      default: "1", // 1 #0071EE 2 #ffffff
    },
    leftArrow: {
      type: Boolean,
      default: true
    },
    rightText: {
      type: String,
      default: "",
    },
    titleName: {
      type: String,
      default: "",
    },
    customBack: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    titleName: {
      handler (val) {
        if (val == '') {
          this.barName = this.$route.meta.title
        } else {
          this.barName = val
        }
      },
      immediate: true
    },
    $route: {
      handler: function (val, oldVal) {
        this.colorTopBg = val.meta.color
      },
      // 深度观察监听
      immediate: true
    }
  },
  data () {
    return {
      barName: "",
      colorTopBg:"",
      barRealHeight:"",
    }
  },
  mounted () {
    $('.van-nav-bar--fixed').css('top', this.topHeight)
    $('.van-nav-bar__content').css('height', '54px')
    this.$nextTick(()=>{
      this.barRealHeight = document.getElementById('barTitle').offsetHeight
      this.$emit('update:barRealHeight',this.barRealHeight)
    })
  },
  methods: {
    onClickLeft () {
      this.$router.back()
    },
    onCustomBackClick () {
      this.$emit('onBackClick')
    },
    onClickRight () {
      this.$emit('onClickRight')
    }
  }
}
</script>

<style scoped>
.dr-bar-title {
  /* height: 54px !important; */
}
#barTitle .van-nav-bar--fixed{
  height: 100%;
}
/deep/.dr-bar-title .van-nav-bar__content {
  background-color: #0071ee;
  /* height: 54px !important; */
}
/deep/.dr-bar-title .van-icon {
  color: #ffffff !important;
}
/deep/.dr-bar-title .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 19px;
}
/deep/.dr-bar-title .van-nav-bar__text {
  color: #ffffff !important;
}
/deep/.dr-bar-title .van-nav-bar__arrow {
  font-size: 26px;
}
/deep/.dr-bar-title .van-nav-bar__left {
  padding: 0 10px;
}

/deep/.dr-bav-bar .van-nav-bar__content {
  background-color: #ffffff;
  /* height: 54px !important; */
}
/deep/.dr-bav-bar .van-icon {
  color: #000000 !important;
}
/deep/.dr-bav-bar .van-nav-bar__title {
  color: #000000 !important;
  font-size: 19px;
}
/deep/.dr-bav-bar .van-nav-bar__text {
  color: #000000 !important;
}
/deep/.dr-bav-bar .van-nav-bar__arrow {
  font-size: 24px;
}
/deep/.dr-bav-bar .van-nav-bar__left {
  padding: 0 10px;
}

/deep/.dr-bar-title1 .van-nav-bar__content {
  background-color: #000000;
  /* height: 54px !important; */
}
/deep/.dr-bar-title1 .van-nav-bar__text {
  color: #ffffff !important;
}
/deep/.dr-bar-title1 .van-nav-bar__arrow {
  font-size: 24px;
}
/deep/.dr-bar-title1 .van-nav-bar__left {
  padding: 0 10px;
}
/deep/.dr-bar-title1 .van-icon {
  color: #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/drTitelBar/index.vue